import { first, switchMap } from "rxjs/operators";
import { ComponentService } from "../component/ComponentService";
export class ComponentController {
    constructor(container, navigator, observer, key, options, componentService) {
        this._container = container;
        this._observer = observer;
        this._navigator = navigator;
        this._options = options != null ? options : {};
        this._key = key;
        this._navigable = key == null;
        // REVIEW:
        this._componentService = componentService
            ? componentService
            : new ComponentService(this._container, this._navigator);
        this._initializeComponents();
        this._navigator.movedToKey$
            .pipe(first((k) => {
            return k != null;
        }))
            .subscribe((k) => {
            this._key = k;
            this._componentService.deactivateCover();
            this._navigator.stateService.start();
            this._navigator.cacheService.start();
            this._observer.startEmit();
        });
        if (key) {
            this._subscribeIsNavigable();
        }
        else {
            this._navigator.movedToKey$
                .pipe(first((k) => {
                return k != null;
            }))
                .subscribe((k) => {
                this._key = k;
                this._componentService.deactivateCover();
                this._navigator.stateService.start();
                this._navigator.cacheService.start();
                this._observer.startEmit();
            });
        }
    }
    get navigable() {
        return this._navigable;
    }
    get(name) {
        return this._componentService.get(name);
    }
    activate(name) {
        this._componentService.activate(name);
    }
    deactivate(name) {
        this._componentService.deactivate(name);
    }
    remove() {
        this._componentService.remove();
        if (this._isNavigableSubscription != null) {
            this._isNavigableSubscription.unsubscribe();
        }
    }
    _initializeComponents() {
        const options = this._options;
        this._uTrue(options.direction, "direction");
        this._uTrue(options.sequence, "sequence");
        this._uTrue(options.keyboard, "keyboard");
        this._uTrue(options.map, "map");
        this._uTrue(options.axisscalebar, "axisscalebar");
    }
    _setNavigable(navigable) {
        if (this._navigable === navigable) {
            return;
        }
        this._navigable = navigable;
        this._observer.navigable$.next(navigable);
    }
    _subscribeIsNavigable() {
        this._isNavigableSubscription = this._navigator.stateService.currentKey$
            .pipe(first(), switchMap((key) => {
            const keyChanged = key == null || key !== this._key;
            if (keyChanged) {
                this._setNavigable(false);
            }
            return keyChanged
                ? this._navigator.moveToKey$(this._key)
                : this._navigator.stateService.currentNode$.pipe(first());
        }))
            .subscribe(() => {
            this._setNavigable(true);
        });
    }
    _uFalse(option, name) {
        if (option === undefined) {
            this._componentService.deactivate(name);
            return;
        }
        if (typeof option === "boolean") {
            if (option) {
                this._componentService.activate(name);
            }
            else {
                this._componentService.deactivate(name);
            }
            return;
        }
        this._componentService.configure(name, option);
        this._componentService.activate(name);
    }
    _uTrue(option, name) {
        if (option === undefined) {
            this._componentService.activate(name);
            return;
        }
        if (typeof option === "boolean") {
            if (option) {
                this._componentService.activate(name);
            }
            else {
                this._componentService.deactivate(name);
            }
            return;
        }
        this._componentService.configure(name, option);
        this._componentService.activate(name);
    }
}
//# sourceMappingURL=ComponentController.js.map